<template>
    <ui-tooltip :class="[css.container, theme && css[theme]]" :width="width" :z-index="zIndex" :class-extra-name="css.content">
        <div :class="css.body" :style="style">?</div>
        <template #content>
            <slot></slot>
        </template>
    </ui-tooltip>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltip } from "various-ui";
//* 样式
import css from "./index.module.less";

//* 组件属性注册
const define = defineProps({
    icon: { type: Number, default: 16 },
    size: { type: Number, default: 24 },
    theme: { type: String as PropType<"grey"> },
    width: { type: Number },
    zIndex: { type: Number },
});

const style = computed(() => {
    return {
        width: define.size + "px",
        height: define.size + "px",
        fontSize: define.icon + "px",
    };
});
</script>
